import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	globalComponentsHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	globalComponentsHeader: {
		id: 'project-directories.components.create-modal.global-components-header',
		defaultMessage: 'Create Jira component',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	header: {
		id: 'project-directories.components.create-modal.header',
		defaultMessage: 'Create component',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	saveButton: {
		id: 'project-directories.components.create-modal.save-button',
		defaultMessage: 'Save',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	cancelButton: {
		id: 'project-directories.components.create-modal.cancel-button',
		defaultMessage: 'Cancel',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});
export default messages;
